module.exports = __webpack_public_path__ + "static/media/basket.0e97983e.svg";